import { createEmptyAction, createPayloadAction } from "../utility/actions";

const RETRIEVE_LEADMARKET_LEAD_TOKEN_START = "RETRIEVE_LEADMARKET_LEAD_TOKEN_START";
const RETRIEVE_LEADMARKET_LEAD_TOKEN_FAILED = "RETRIEVE_LEADMARKET_LEAD_TOKEN_FAILED";
const RETRIEVE_LEADMARKET_LEAD_TOKEN_SUCCESS = "RETRIEVE_LEADMARKET_LEAD_TOKEN_SUCCESS";

const actions = {
  RETRIEVE_LEADMARKET_LEAD_TOKEN_START,
  RETRIEVE_LEADMARKET_LEAD_TOKEN_FAILED,
  RETRIEVE_LEADMARKET_LEAD_TOKEN_SUCCESS,
  submitLeadMarket: createPayloadAction(RETRIEVE_LEADMARKET_LEAD_TOKEN_START),
  submitLeadMarketFailed: createEmptyAction(RETRIEVE_LEADMARKET_LEAD_TOKEN_FAILED),
  submitLeadMarketSuccess: createPayloadAction(RETRIEVE_LEADMARKET_LEAD_TOKEN_SUCCESS),
};

export default actions;
